import React from 'react';
import SideBarComponent from 'components/commandpanel/ExperimentPanel/SideBarComponent/SideBarComponent';
import ImageTuningManager from 'components/well/imageTuningManager';
import DrawingCreationTools from './drawingCreationTools';
import DrawingTools from './drawingTools';
const ImageToolsContainer = () => {
  return (
    <div id="imagetoolscontainer" className="flex flex-col w-full">
      <DrawingCreationTools enforceConditions={false} />
      <SideBarComponent
        heading={'Tool Options'}
        isCollapsible={true}
        handleColapse={() => {}}
        ContainerComponent={<DrawingTools />}
      />
      <SideBarComponent
        heading={'Image Tuning'}
        isCollapsible={true}
        handleColapse={() => {}}
        ContainerComponent={<ImageTuningManager />}
      />
    </div>
  );
};

export default ImageToolsContainer;
